import { gql, graphql } from "react-apollo"
import type { OperationComponent } from "react-apollo"

export const GetSensorsQuery = gql`
  query GetSensors($query: String!) {
    sensors(searchQuery: $query) {
      friendlyName
      id
      serialNumber
      latitude
      longitude
      stationName
    }
  }
`

type Sensor = {
  friendlyName: string,
  id: string,
  serialNumber: string,
  latitude: number,
  longitude: number,
  stationName: string
}

type Response = {
  sensors: Sensor[]
}

export type InputProps = {
  searchName: string
}

const withSensors: OperationComponent<
  Response,
  InputProps
> = graphql(GetSensorsQuery, {
  name: "sensors",
  options: ({ searchName }) => ({ variables: { query: searchName } })
})

export default withSensors



// WEBPACK FOOTER //
// ./src/Sensors/queries/withSensors.js